var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGalleryMenuActiveIcons(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 25.537,
    viewBox: "0 0 28 25.537",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "image_17693036",
    d: "M26.609,6.678H11.817A3.947,3.947,0,0,0,8,9.68H21.493A6.009,6.009,0,0,1,27.5,15.685v11.03a3.947,3.947,0,0,0,3-3.818V10.57a3.909,3.909,0,0,0-3.891-3.891Zm-5.116,5.4H6.1a3.614,3.614,0,0,0-3.6,3.6V28.612a3.6,3.6,0,0,0,3.592,3.6h15.4a3.614,3.614,0,0,0,3.6-3.6V15.685a3.628,3.628,0,0,0-3.6-3.6ZM9.966,17.445a2.173,2.173,0,1,1-2.185,2.16A2.174,2.174,0,0,1,9.966,17.445ZM22.7,28.612a1.221,1.221,0,0,1-1.2,1.2H6.1a1.2,1.2,0,0,1-.915-.433l9.848-7.924a1.482,1.482,0,0,1,1.9,0L22.7,26.093v2.519Z",
    transform: "translate(-2.5 -6.678)",
    fill: "#ef7800"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalleryMenuActiveIcons);
export default __webpack_public_path__ + "static/media/gallery_menu__active_icons.836c8b55e7eab135a64966a203a96975.svg";
export { ForwardRef as ReactComponent };